import { namespace }  from './appNamespace';

export const ALLOW_MAIN_CONTENT_OVERFLOW = namespace + '/ALLOW_MAIN_CONTENT_OVERFLOW';
export const HIDE_LOADING_SPINNER = namespace + '/HIDE_LOADING_SPINNER';
export const SHOW_ERROR_PAGE = namespace + '/SHOW_ERROR_PAGE';
export const SHOW_MAINTENANCE_PAGE = namespace + '/SHOW_MAINTENANCE_PAGE';
export const SET_BASE_PATH = namespace + '/SET_BASE_PATH';
